module.exports = __webpack_public_path__ + "img/teacher3.884ae6b0.png";